<!-- Form horizontal -->
<div class="card">
    <div class="card-header header-elements-inline">
        <h5  class="card-title">{{ !isEditMode ? 'Add Admin' : 'Edit Admin'}}</h5>
    </div>
    <div class="card-body">
        <form class="form-horizontal" action="#" [ngBusy]="busy">
            <div class="row">
                <div class="form-group col-md-4">
                    <label class="control-label">Nom : </label>
                    <input [(ngModel)]="admin.name" name="nom" type="text" class="form-control">
                    <label *ngIf="submitted&&!admin.name" class="form-text text-danger">required</label>
                </div>

                <div class="form-group col-md-4">
                    <label class="control-label">Email : </label>
                    <input [(ngModel)]="admin.email" [disabled]="isEditMode" name="email" type="text" class="form-control">
                    <label *ngIf="submitted&&!admin.email" class="form-text text-danger">required</label>
                </div>

                <div class="form-group col-md-4">
                    <label class="control-label">Mobile : </label>
                    <input [(ngModel)]="admin.mobile" name="phone" type="text" class="form-control">
                    <label *ngIf="submitted&&!admin.mobile" class="form-text text-danger">required</label>
                </div>
            </div>
            <div class="row">
                <!-- Add this block for the dropdown -->
                <div class="form-group col-6">
                  <label class="control-label">Pôle : </label>
                  <select [(ngModel)]="admin.pole" name="pole" class="form-control">
                    <option [ngValue]="null">-- Select a pole --</option>
                    <option value="comptabilite">Pôle Comptabilité</option>
                    <option value="sociale">Pôle Sociale</option>
                  </select>
                  <label *ngIf="submitted && !admin.pole" class="form-text text-danger">required</label>
                </div>
              

            
                <div class="form-group col-6">
                    <label class="control-label">Password</label>
                    <input [(ngModel)]="admin.passwordDecrypt" [disabled]="isEditMode" name="password" type="text" class="form-control">
                    <label *ngIf="submitted&&!admin.passwordDecrypt"
                           class="form-text text-danger">required</label>
                    <button (click)="generatePassword()" [disabled]="isEditMode" type="button" class="btn btn-primary mt-2" id="password"
                            style="float:right;">
                        <i class="fa fa-at"></i>
                        Generate Password
                    </button>

                </div>
                
                
            </div>
            <br>
            <div class="row text-center">
                <button type="submit" (click)="submitClient()" class="btn btn-primary">
                    {{ !isEditMode ? 'Add Admin' : 'Edit Admin'}}
                    <i class="icon-arrow-right14 position-right"></i></button>
            </div>

        </form>
    </div>
</div>
